import SkeletonLine from '../../components/UI/SkeletonLine';

const LOGO_WIDTHS = ['128px', '156px', '92px', '132px', '118px', '154px'];

export default function BusinessLandingSkeleton() {
  return (
    <main aria-busy="true" aria-label="Loading business page">
      <div className="h-[460px] bg-bg-dark-green mobile:h-[500px] tablet:h-[580px]" />

      <section className="px-5 pb-20 pt-7 tablet:px-8">
        <div className="mx-auto max-w-[1096px]">
          <SkeletonLine
            dark
            height="26px"
            margin="0 auto 34px"
            width="360px"
          />

          <div
            className="flex items-center justify-between gap-8 overflow-hidden"
            aria-hidden="true"
          >
            {LOGO_WIDTHS.map((width, index) => (
              <SkeletonLine
                dark
                height={index % 2 === 0 ? '34px' : '40px'}
                key={`${width}-${index}`}
                margin="0"
                width={width}
              />
            ))}
          </div>

          <div className="mx-auto mt-24 max-w-[760px]">
            <SkeletonLine dark height="44px" margin="0 0 14px" />
            <SkeletonLine
              dark
              height="44px"
              margin="0 auto"
              width="68%"
            />
          </div>
        </div>
      </section>
    </main>
  );
}
